import { throttle } from 'throttle-debounce';

let supportsPassive = false;
try {
    const opts = Object.defineProperty({}, 'passive', {
        // eslint-disable-next-line
        get: () => {
            supportsPassive = true;
        },
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
} catch (e) {
    supportsPassive = false;
}

export const onScroll = (cb, target = window) => {
    const callback = throttle(50, cb);
    target.addEventListener('scroll', callback, supportsPassive ? { passive: true } : false);
    return () => {
        target.removeEventListener('scroll', callback, supportsPassive ? { passive: true } : false);
    };
};
